import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { BASE_CAMPAIGN_COLUMNS, BASE_WORKFLOW_COLUMNS, CAMPAIGN } from './constants';
import { Cell, BodyCheckboxCell } from './ReportDataSourceTable.styled';

export const generateHeaderColumns = (onSelectIds, rows, selectedTypeIdsInModal, componentType) => {
  let status =
    selectedTypeIdsInModal.length > 0 ? CHECKBOX_STATUS.INDETERMINATE : CHECKBOX_STATUS.UNCHECKED;
  if (rows.every((item) => selectedTypeIdsInModal.includes(item.id))) {
    status = CHECKBOX_STATUS.CHECKED;
  }

  const onClick = () => {
    const ids = rows.map((row) => row.id);
    onSelectIds(ids, status !== CHECKBOX_STATUS.CHECKED);
  };

  return [
    {
      sortable: false,
      name: (
        <Cell>
          <Checkbox id="group" onClick={onClick} status={status} />
        </Cell>
      ),
      value: 'checky-header',
    },
    ...(componentType === CAMPAIGN ? BASE_CAMPAIGN_COLUMNS : BASE_WORKFLOW_COLUMNS),
  ];
};

export const generateRowColumns = (onSelectId, selectedTypeIdsInModal, componentType) => {
  return [
    {
      sortable: false,
      value: 'checky-row',
      RowCell: ({ row }) => {
        const status = selectedTypeIdsInModal.includes(row.id)
          ? CHECKBOX_STATUS.CHECKED
          : CHECKBOX_STATUS.UNCHECKED;
        const onClick = () => {
          if (status === CHECKBOX_STATUS.CHECKED) {
            onSelectId(row.id, false);
          } else {
            onSelectId(row.id, true);
          }
        };
        return (
          <BodyCheckboxCell>
            <Checkbox id={`checkbox-${row.id}`} onClick={onClick} status={status} />
          </BodyCheckboxCell>
        );
      },
    },
    ...(componentType === CAMPAIGN ? BASE_CAMPAIGN_COLUMNS : BASE_WORKFLOW_COLUMNS),
  ];
};
